import { useEffect } from "react";
import { useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { userServices } from "../../../APIServices/UserData/userServices";
import Multiselect from "multiselect-react-dropdown";

const ConfigureCountryRestriction = ({
  show,
  hide,
  title,
  widgetCountryRestrictionSettings,
  setWidgetCountryRestrictionSettings,
  toggleWidgetCountryRestrictionSettings,
  initialCountryRestrictionSettings
}) => {
  const [countryList, setCountryList] = useState([])

  const getCountries = async () => {
    let data = await userServices.getCountries();
    let result = data?.data || [];
    let countryList = result.map(item => ({
      label: item.name,
      value: item.iso3
    }));
    setCountryList(countryList);
  };

  const handleMultiSelectChange = (type, selectedList) => {
    setWidgetCountryRestrictionSettings((prev) => ({
      ...prev,
      [type]: [...new Set(selectedList.map((item) => item.value))],
    }));
  };

  const mapValuesToLabels = (values) => {
    return countryList.filter((opt) =>
      values.includes(opt.value)
    );
  };

  const filterOptions = (type) => {
    return countryList.filter(
      (opt) =>
        !widgetCountryRestrictionSettings?.[type]?.includes(opt.value)
    );
  };

  useEffect(() => {
    getCountries()
  }, []);
  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <h6>Country Restriction</h6>
          <p style={{ fontSize: 12 }}>
            By default, channel is available to all countries. You can restrict your channel by allowing or denying specific countries
          </p>
          <Form.Check
            type="switch"
            id="show-toggle"
            style={{ fontSize: 12 }}
            label="Show widget only to visitors of the following countries"
            checked={widgetCountryRestrictionSettings?.showEnabled}
            onChange={(e) =>
              toggleWidgetCountryRestrictionSettings("showEnabled", e.target.checked)
            }
            className="mb-2"
          />
          {widgetCountryRestrictionSettings?.showEnabled && (
            <div className="mb-3">
              <Multiselect
                displayValue="label"
                onKeyPressFn={() => { }}
                onSearch={() => { }}
                placeholder="Select Country"
                options={filterOptions("showCountries")}
                selectedValues={mapValuesToLabels(
                  widgetCountryRestrictionSettings?.showCountries
                )}
                onSelect={(list) =>
                  handleMultiSelectChange("showCountries", list)
                }
                onRemove={(list) =>
                  handleMultiSelectChange("showCountries", list)
                }
              />
            </div>
          )}
          <Form.Check
            type="switch"
            id="hide-toggle"
            style={{ fontSize: 12 }}
            label="Hide widget only from visitors of the following countries"
            checked={widgetCountryRestrictionSettings?.hideEnabled}
            onChange={(e) =>
              toggleWidgetCountryRestrictionSettings("hideEnabled", e.target.checked)
            }
            className="mb-2"
          />
          {widgetCountryRestrictionSettings?.hideEnabled && (
            <Multiselect
              displayValue="label"
              onKeyPressFn={() => { }}
              onSearch={() => { }}
              placeholder="Select Country"
              options={filterOptions("hideCountries")}
              selectedValues={mapValuesToLabels(
                widgetCountryRestrictionSettings?.hideCountries
              )}
              onSelect={(list) =>
                handleMultiSelectChange("hideCountries", list)
              }
              onRemove={(list) =>
                handleMultiSelectChange("hideCountries", list)
              }
            />
          )}
          {widgetCountryRestrictionSettings?.countryRestriction &&
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                size="sm"
                variant="outline-danger"
                onClick={() => setWidgetCountryRestrictionSettings(initialCountryRestrictionSettings)}
              >
                Reset
              </Button>
            </div>
          }
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ConfigureCountryRestriction;
